module.exports = __webpack_public_path__ + "static/two-ce55af81d6a5c0a7834872b59a123156.jpeg";